module.exports = __webpack_public_path__ + "static/media/南厍村.e6cce128.png";